import { render, staticRenderFns } from "./ViewPages.vue?vue&type=template&id=40fb6f43"
import script from "./ViewPages.vue?vue&type=script&lang=js"
export * from "./ViewPages.vue?vue&type=script&lang=js"
import style0 from "./ViewPages.vue?vue&type=style&index=0&id=40fb6f43&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports